import { createComponent } from '@/helpers/alpine';
import prestashop from 'prestashop';

const Pagination = createComponent(() => ({
    init() {
        this.setupPrevBtn();

        prestashop.on('updateProductListDom', () => {
            this.setupPrevBtn();
        });
    },

    next() {
        const btn = this.$refs.nextBtn as HTMLAnchorElement;

        this.getProductsListTemplate(btn.href).then((data) => {
            if ('products' in data) {
                const parser = new DOMParser();
                const renderedProducts = parser.parseFromString(
                    data.rendered_products,
                    'text/html',
                );
                const newProducts = renderedProducts.querySelectorAll(
                    '.js-product',
                ) as NodeListOf<HTMLElement>;
                const productsList = document.querySelector(
                    '.js-products-list',
                ) as HTMLElement;

                productsList?.insertAdjacentHTML(
                    'beforeend',
                    Array.from(newProducts)
                        .map((product) => product.outerHTML)
                        .join(''),
                );

                history.pushState({}, '', btn.href);
            }
            if (
                'pagination' in data &&
                data.pagination.current_page < data.pagination.pages_count
            ) {
                btn.href = btn.href.replace(
                    /([?&]page=)(\d+)/,
                    (_, p1) => `${p1}${data.pagination.current_page + 1}`,
                );
            } else {
                btn.remove();
            }
        });
    },

    prev(btn: HTMLAnchorElement) {
        this.getProductsListTemplate(btn.href).then((data) => {
            if ('products' in data) {
                const parser = new DOMParser();
                const renderedProducts = parser.parseFromString(
                    data.rendered_products,
                    'text/html',
                );
                const newProducts = renderedProducts.querySelectorAll(
                    '.js-product',
                ) as NodeListOf<HTMLElement>;
                const productsList = document.querySelector(
                    '#js-product-list .products',
                );

                if (productsList)
                    newProducts.forEach((product) => {
                        productsList.prepend(product);
                    });

                history.pushState({}, '', btn.href);
            }
            if ('pagination' in data && data.pagination.current_page > 1) {
                btn.href = btn.href.replace(
                    /([?&]page=)(\d+)/,
                    (_, p1) => `${p1}${data.pagination.current_page - 1}`,
                );
            } else {
                btn.remove();
            }
        });
    },

    async getProductsListTemplate(url: string) {
        if (url.indexOf('action=moreProducts') === -1) {
            url += '&action=moreProducts';
        }
        url += '&from-xhr';

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(`Error! status: ${response.status}`);
        }
        return data;
    },

    setupPrevBtn() {
        const wrapper = document.querySelector(
            '.js-pagination-btn-prev-wrapper',
        ) as HTMLElement;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const pageQuery = urlParams.get('page');
        wrapper.innerHTML = '';

        if (pageQuery && Number(pageQuery) > 1) {
            const button = document.createElement('a');
            button.className =
                'js-pagination-btn-prev js-pagination-btn btn btn-ui-black btn-s-lg w-full max-w-[408px] mt-8';
            button.href =
                window.location.href.split('?')[0] +
                '?page=' +
                (Number(pageQuery) - 1);
            button.innerText = wrapper.getAttribute('data-text') as string;
            wrapper?.appendChild(button);

            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
                window.scrollTo({ top: 0 });
            }

            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.prev(button);
            });
        }
    },
}));

export { Pagination };
